/* ============ YANKEE CANDLE - JS DEEL 1: DATABASE & VRAGEN ============ */

// 1. DE VOLLEDIGE DATABASE (Alle Yankee Candle producten uit jouw bronbestand)
const PRODUCTS = [
  {"title":"Yankee Candle - A Calm & Quiet Place - Large Jar","geur":"vers; gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_982e1202-51d3-4e9f-b86e-9bd70848d47a.webp?v=1775561769"},
  {"title":"Yankee Candle - Amber & Sandalwood - Large Jar","geur":"houtig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_2bf6d28b-0b74-497a-916b-bc7391e8a3f4.webp?v=1775562036"},
  {"title":"Yankee Candle - Autumn Daydream - Large Jar","geur":"kruidig; houtig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_52f2fb25-8cca-451c-b6d2-806ebdd39a39.webp?v=1775562370"},
  {"title":"Yankee Candle - Banoffee Waffle Signature Large Jar","geur":"zoet; vanille","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/image_250667d1-f379-4124-a298-9b7bb79e9474.jpg?v=1781860308"},
  {"title":"Yankee Candle - Bayside Cedar - Large Jar","geur":"fruitig; houtig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_b1efacbc-d8e6-4ab4-b5cc-714f606c2e52.webp?v=1775567721"},
  {"title":"Yankee Candle - Black Cherry - Large Jar","geur":"zoet; fruitig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_70544e96-4225-4235-9611-77530f9fd9b1.webp?v=1775568276"},
  {"title":"Yankee Candle - Blooming Love - Large Jar","geur":"gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/94963153-8fa1-347f-92a9-af6f5183c073.png?v=1776336237"},
  {"title":"Yankee Candle - Cinnamon Stick - Large Jar","geur":"kaneel; kruidig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_03629a78-9fc3-4b1b-8e79-cf8e67577db8.webp?v=1776337753"},
  {"title":"Yankee Candle - Clean Cotton - Large Jar","geur":"vers; fris-beddengoed","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_8263e9fc-84bf-42af-b818-8613744caed2.webp?v=1776338566"},
  {"title":"Yankee Candle - Cliffside Sunrise - Large Jar","geur":"fruitig; gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/4ed7fefa-7b83-3646-b6c4-6afb917c4714.webp?v=1776339575"},
  {"title":"Yankee Candle - Coconut Beach - Large Jar","geur":"fruitig; vers","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_b5c22988-507e-4fad-8fe2-d7b33a8bd0f2.webp?v=1776341123"},
  {"title":"Yankee Candle - Cucumber Mint Cooler - Large Jar","geur":"vers; fruitig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_a0843b8e-6437-4008-a4e3-c29f2af6dba2.webp?v=1776434853"},
  {"title":"Yankee Candle - Dried Lavender & Oak - Large Jar","geur":"gebloemd; houtig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_b0b34996-6b16-4481-88d5-9e0ce414b7dd.webp?v=1776434953"},
  {"title":"Yankee Candle - Enchanting Cherry Blossoms - Large Jar","geur":"gebloemd; fruitig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_6b231510-1151-4c3c-8efd-c5b4b6539093.webp?v=1776435009"},
  {"title":"Yankee Candle - Fresh Cut Roses Signature Large Jar","geur":"gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/Fresh-Cut-Roses_jar-scaled-jpg_grande_803dd235-8ad0-4acc-94ad-e18e6e4f93b1.webp?v=1781860401"},
  {"title":"Yankee Candle - Holiday Cheer Signature Large Jar","geur":"kruidig; zoet","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/Holiday_Cheer_Large_1.webp?v=1782369411"},
  {"title":"Yankee Candle - Iced Berry Lemonade - Large Jar","geur":"fruitig; citrus","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_4752e50e-e3ec-4cc7-b49a-03be3b0fd95e.webp?v=1776435675"},
  {"title":"Yankee Candle - Lavender Bliss - Large Jar","geur":"gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/b0d9e1b7-41f9-3ff9-ba34-cfe74c6ac41b.png?v=1776435854"},
  {"title":"Yankee Candle - Lavender Vanilla - Large Jar","geur":"gebloemd; vanille","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_b9f2f4b9-db29-4847-afff-de52cb64da12.webp?v=1776435953"},
  {"title":"Yankee Candle - Lemon Lavender - Large Jar","geur":"gebloemd; citrus","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_27ad4349-58f8-4b6d-9b6d-9d9e763b9a70.webp?v=1776436638"},
  {"title":"Yankee Candle - Midnight Jasmine - Large Jar","geur":"gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/22b62d09-09a8-325b-ba38-4b22195f5374.webp?v=1776437342"},
  {"title":"Yankee Candle - Midsummer's Night - Large Jar","geur":"houtig; kruidig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_f46f4b11-56a4-4674-81df-964e800409d2.webp?v=1776437539"},
  {"title":"Yankee Candle - Ocean Air - Large Jar","geur":"vers; aquatisch","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_cbe8b509-89aa-41b7-ab0c-e6fac4926786.webp?v=1776437696"},
  {"title":"Yankee Candle - Pink Sands - Large Jar","geur":"fruitig; gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_ccbace08-1dd3-47f7-a4cd-a91ff3d30bbc.webp?v=1776347190"},
  {"title":"Yankee Candle - Pink Sands Glow - Large Jar","geur":"fruitig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_e46c7a8e-9e66-424c-a74b-4958b5df2ccd.webp?v=1776678021"},
  {"title":"Yankee Candle - Red Raspberry - Large Jar","geur":"fruitig; zoet","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_74deb80a-8f76-420d-bec9-9633f13d3a3c.webp?v=1776678527"},
  {"title":"Yankee Candle - Sage & Citrus - Large Jar","geur":"gebloemd; citrus","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_aa6fa422-136e-48d0-b5f3-178aad8fc9a4.webp?v=1776678710"},
  {"title":"Yankee Candle - Seaside Woods - Large Jar","geur":"houtig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_620eac3b-dab8-402e-b83a-83cfe7a393ec.webp?v=1776678830"},
  {"title":"Yankee Candle - Serenity Stone - Large Jar","geur":"aquatisch; vers","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/2672619E_YC_LargeJar_SerenityStone_ProductShot_1152x1152_f38dd068-0f63-4e97-af4a-977cedbd3f49.webp?v=1776678889"},
  {"title":"Yankee Candle - Slow Bloom - Large Jar","geur":"gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/HMFG0089_2672617E_CFC1_EMEA_Image_01.jpg?v=1776681641"},
  {"title":"Yankee Candle - Soft Blanket - Large Jar","geur":"fris-beddengoed; vers","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_dfbbdfdd-cd83-4069-a72e-922e148d47d3.webp?v=1776681915"},
  {"title":"Yankee Candle - Starfruit & Sunshine - Large Jar","geur":"fruitig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload.webp?v=1776682641"},
  {"title":"Yankee Candle - Sun & Sand - Large Jar","geur":"vers; aquatisch","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_18c02274-78f8-451b-ad00-dff7d93e56f5.webp?v=1776682945"},
  {"title":"Yankee Candle - Tangerine & Vanilla - Large Jar","geur":"citrus; vanille","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_afa4bab6-2d8c-46b1-9ac7-cde86280461d.webp?v=1776683057"},
  {"title":"Yankee Candle - Vanilla Crème Brulee - Large Jar","geur":"zoet; vanille","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_439b767d-3c79-4e28-9ca2-4b25b057bdfd.webp?v=1776683554"},
  {"title":"Yankee Candle - Vanilla Cupcake - Large Jar","geur":"zoet; vanille","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_77dc12d1-0022-40db-8296-15b0b34f9d8d.webp?v=1776684135"},
  {"title":"Yankee Candle - Wedding Day Signature Large Jar","geur":"gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/WeddingDay_jar.webp?v=1782369222"},
  {"title":"Yankee Candle - White Strawberry Bellini - Large Jar","geur":"fruitig; zoet","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_a87dc51c-e33d-4e52-96f2-f135da92b36e.webp?v=1776684839"},
  {"title":"Yankee Candle - Wild Orchid - Large Jar","geur":"fruitig; gebloemd","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/BC_Upload_4e4f5825-30c1-4aaa-8889-cda3c7ac0ddb.webp?v=1776685457"},
  {"title":"Yankee Candle - Black Cherry - Geurstokjes 100 ml","geur":"zoet; fruitig","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/Reed_Diffuser_Box_Silo_Black_Cherry.jpg?v=1782469009"},
  {"title":"Yankee Candle - Clean Cotton - Geurstokjes 100 ml","geur":"vers; fris-beddengoed","img":"https://cdn.shopify.com/s/files/1/1007/8470/1775/files/14b017c3-f32e-36fa-b3ad-d06a9aeaea24.jpg?v=1779109642"}
];

// 2. CONFIGURATIE (DNA FAMILIES)
const FAMILIES = [
  {key:'bloemig', label:'Bloemig', color:'#EA6A60'},
  {key:'fruitig', label:'Fruitig', color:'#F59331'},
  {key:'zoet', label:'Zoet & Gourmand', color:'#EE6FAE'},
  {key:'vanille', label:'Vanille', color:'#F4C033'},
  {key:'houtig', label:'Houtachtig', color:'#C2814A'},
  {key:'kruidig', label:'Kruidig', color:'#B45FA8'},
  {key:'fris', label:'Fris & Citrus', color:'#36B97F'},
  {key:'aqua', label:'Aqua & Oceaan', color:'#2BA8D4'}
];

const TAG2FAM = {
  gebloemd:'bloemig', fruitig:'fruitig', zoet:'zoet', vanille:'vanille', 
  houtig:'houtig', kruidig:'kruidig', kaneel:'kruidig', oosters:'kruidig',
  vers:'fris', 'fris-beddengoed':'fris', citrus:'fris', zeebries:'aqua', aquatisch:'aqua'
};

const tagLabels = {
  gebloemd:'Bloemig', vers:'Fris', houtig:'Houtachtig', fruitig:'Fruitig', 
  zoet:'Zoet', vanille:'Vanille', citrus:'Citrus', zeebries:'Oceaanbries', 
  aquatisch:'Aquatisch', kruidig:'Kruidig', 'fris-beddengoed':'Fris linnen', 
  kaneel:'Kaneel', oosters:'Oosters'
};

// 3. DE 5 UITGEBREIDE VRAGEN
const QUESTIONS = [
  {id:'sfeer', q:'Welke sfeer wil je creëren?', two:true, options:[
    {label:'Fris & Schoon', sub:'Geuren van pas gewassen linnen en de ochtendzon', tags:{vers:2, 'fris-beddengoed':2, citrus:1}},
    {label:'Warm & Geborgen', sub:'Gezellige avonden met zachte vanille en kaarslicht', tags:{vanille:2, zoet:1, kaneel:1}},
    {label:'Bloemig & Romantisch', sub:'Een weelderig boeket verse snijbloemen', tags:{gebloemd:2, fruitig:1}},
    {label:'Krachtig & Luxe', sub:'Diepe houtnoten en oosterse specerijen', tags:{houtig:2, kruidig:2, oosters:1}}
  ]},
  {id:'moment', q:'Wanneer brand jij het liefst een kaars?', options:[
    {label:'Tijdens de ochtendroutine', tags:{vers:1, citrus:1, fris:1}},
    {label:'Als ik bezoek krijg', tags:{fruitig:1, zoet:1, gebloemd:1}},
    {label:'Tijdens een ontspannen bad', tags:{aqua:1, vers:1, 'fris-beddengoed':1}},
    {label:'Op een koude winteravond', tags:{vanille:1, kaneel:1, kruidig:1}}
  ]},
  {id:'interieur', q:'Welke stijl past bij jouw huis?', options:[
    {label:'Modern & Minimalistisch', tags:{vers:1, aqua:1, 'fris-beddengoed':1}},
    {label:'Klassiek & Elegant', tags:{gebloemd:1, houtig:1, oosters:1}},
    {label:'Landelijk & Warm', tags:{vanille:1, zoet:1, kaneel:1}},
    {label:'Bohemian & Kleurrijk', tags:{fruitig:1, citrus:1, kruidig:1}}
  ]},
  {id:'bestemming', q:'Waar reis je in gedachten naartoe?', options:[
    {label:'Een tropisch strand', tags:{aqua:2, fruitig:1, citrus:1}},
    {label:'Een bloeiend Engels platteland', tags:{gebloemd:2, vers:1}},
    {label:'Een mystieke markt in Marrakesh', tags:{oosters:2, kruidig:1, houtig:1}},
    {label:'Een blokhut in de bergen', tags:{houtig:2, den:1, kaneel:1}}
  ]},
  {id:'persoonlijkheid', q:'Welke omschrijving past het beste bij jou?', options:[
    {label:'Rustig & Nuchter', tags:{vers:1, 'fris-beddengoed':1, aqua:1}},
    {label:'Sociaal & Uitbundig', tags:{fruitig:1, zoet:1, citrus:1}},
    {label:'Creatief & Intuïtief', tags:{kruidig:1, oosters:1, gebloemd:1}},
    {label:'Zorgzaam & Huiselijk', tags:{vanille:1, kaneel:1, houtig:1}}
  ]}
];
/* ============ YANKEE CANDLE - JS DEEL 2: NAVIGATIE & LINKS ============ */

let step = 0; 
let answers = {};
const $ = id => document.getElementById(id);

// 1. STRICT SCREEN MANAGEMENT
// Verbergt alle schermen en toont alleen de gevraagde ID
function show(id) {
  const screens = document.querySelectorAll('.geurkompas-wrapper .screen');
  screens.forEach(s => {
    s.classList.remove('active');
  });
  
  const target = $(id);
  if (target) {
    target.classList.add('active');
  }
  // Altijd terug naar boven scrollen bij nieuwe stap
  window.scrollTo({top: 0, behavior: 'smooth'});
}

// 2. START DE QUIZ
function start() {
  step = 1;
  answers = {};
  renderQuestion();
  updateProgress();
  show('screen-q');
}

// 3. RENDER VRAGEN & OPTIES
function renderQuestion() {
  const q = QUESTIONS[step-1];
  
  // Als er geen vragen meer zijn, bereken direct de resultaten (Slaat e-mail over)
  if (!q) { 
    finish(); 
    return; 
  }
  
  // Update labels
  $('qlabel').textContent = `Stap ${step} van ${QUESTIONS.length}`;
  $('qtitle').textContent = q.q;
  
  // Render opties
  const box = $('qoptions');
  box.className = 'options' + (q.two ? ' two' : '');
  box.innerHTML = '';
  
  q.options.forEach(opt => {
    const btn = document.createElement('button');
    btn.className = 'opt';
    btn.innerHTML = `<span class="olabel">${opt.label}</span><span class="osub">${opt.sub || ''}</span>`;
    
    btn.onclick = () => {
      answers[q.id] = opt;
      step++;
      renderQuestion();
      updateProgress();
    };
    box.appendChild(btn);
  });

  // Navigatie bolletjes (dots) updaten
  let dotHtml = '';
  for(let i = 1; i <= QUESTIONS.length; i++) {
    dotHtml += `<span class="dot ${i <= step ? 'on' : ''}"></span>`;
  }
  $('dots').innerHTML = dotHtml;
  
  // Toon/verberg terug-knop
  $('backBtn').style.display = step > 1 ? 'inline-flex' : 'none';
}

// 4. TERUG NAVIGEREN
function back() {
  if (step > 1) {
    step--;
    renderQuestion();
    updateProgress();
  } else {
    // Terug naar startscherm als we bij vraag 1 zijn
    location.reload(); 
  }
}

// 5. PROGRESSIE BEREKENEN
function updateProgress() {
  // We berekenen de balk op basis van 5 vragen + resultaat scherm
  const totalSteps = QUESTIONS.length + 1;
  const pct = (step / totalSteps) * 100;
  if($('prog')) {
    $('prog').style.width = pct + '%';
  }
}

// 6. FINISH (Directe overgang naar resultaat)
function finish() {
  step = QUESTIONS.length + 1; // Zet op laatste stap voor progressiebalk
  updateProgress();
  computeResults(); // Deze functie komt in Deel 3
  show('screen-results');
  if (window.fireConfetti) fireConfetti(); // Confetti trigger
}

// 7. DE HANDLE GENERATOR (CRUCIAAL VOOR LINKS)
function createHandle(title) {
  let name = title.toLowerCase()
    .replace("yankee candle - ", "")
    .replace(" signature", "")
    .replace(" jar", "-jar") 
    .replace(" 100 ml", "");
    
  // SPECIFIEKE FIX VOOR MIDSUMMER'S NIGHT
  // Verandert "midsummer's" in "midsummers" (zonder extra streepje voor de S)
  if(name.includes("midsummer's")) {
    name = name.replace("midsummer's", "midsummers");
  }

  return name
    .replace(/[^a-z0-9]+/g, '-')     // Vervang speciale tekens/spaties door 1 streepje
    .replace(/(^-|-$)/g, '')        // Verwijder streepjes aan begin en eind
    .replace(/-+/g, '-');           // Voorkom dubbele streepjes (-- wordt -)
}
/* ============ YANKEE CANDLE - JS DEEL 3: BEREKENING & VISUALS ============ */

// 1. DE RESULTATEN BEREKENEN
function computeResults() {
  const prefTags = {};
  
  // Tel alle punten van de 5 vragen bij elkaar op
  Object.values(answers).forEach(ans => {
    if(ans.tags) {
      for(let t in ans.tags) {
        prefTags[t] = (prefTags[t] || 0) + ans.tags[t];
      }
    }
  });

  // Score elk product uit de database
  const scored = PRODUCTS.map(p => {
    const tags = p.geur.split(';').map(s => s.trim());
    let score = 0;
    tags.forEach(t => {
      if (prefTags[t]) score += prefTags[t];
    });
    return { ...p, _score: score, _tags: tags };
  }).sort((a,b) => b._score - a._score); // Hoogste score bovenaan

  const chosen = scored.slice(0, 3);
  
  // Render de onderdelen
  renderPassport(prefTags);
  renderCards(chosen);
}

// 2. HET PASPOORT EN DNA BALKJES RENDEREN
function renderPassport(prefTags) {
  // Sorteer tags op sterkte voor de top 5 balkjes
  const sortedTags = Object.entries(prefTags).sort((a,b) => b[1]-a[1]).slice(0, 5);
  
  $('dnaRows').innerHTML = sortedTags.map(([tag, val]) => {
    const color = FAMILIES.find(f => f.key === TAG2FAM[tag])?.color || '#ccc';
    const label = tagLabels[tag] || tag;
    // We vermenigvuldigen de breedte voor een mooie vulling (max 100%)
    const barWidth = Math.min(100, (val / sortedTags[0][1]) * 100);
    
    return `
      <div class="dna-row">
        <div class="name">${label}</div>
        <div class="dna-bar">
          <span style="width:${barWidth}%; background:${color}"></span>
        </div>
      </div>`;
  }).join('');

  // Bereken de intensiteit voor het Rad (Kompas) per familie
  const inten = {};
  FAMILIES.forEach(f => {
    let familyScore = 0;
    Object.keys(TAG2FAM).filter(t => TAG2FAM[t] === f.key).forEach(t => {
      familyScore += (prefTags[t] || 0);
    });
    inten[f.key] = Math.min(1, familyScore / 3);
  });
  
  $('kompasResult').innerHTML = buildKompas(inten);

  // Persona tekst op basis van de nummer 1 tag
  const topTagKey = sortedTags[0] ? sortedTags[0][0] : 'vers';
  const topLabel = tagLabels[topTagKey] || 'Frisse';
  $('persona').innerHTML = `Jouw Geur-DNA is uniek. Je hebt een duidelijke voorkeur voor <strong>${topLabel.toLowerCase()}</strong> geuren. Dit past perfect bij een huis waar balans, sfeer en comfort centraal staan.`;
}

// 3. PRODUCT KAARTEN RENDEREN (Met 1, 2, 3 nummering)
function renderCards(list) {
  $('cards').innerHTML = list.map((p, i) => {
    // Statische percentages die geloofwaardig aflopen
    const matchPct = 98 - (i * 4);
    const handle = createHandle(p.title);
    
    return `
      <div class="card">
        <span class="rank">${i + 1}</span>
        <div class="thumb"><img src="${p.img}" alt="${p.title}" loading="lazy"></div>
        <div class="cbody">
          <div class="brand">Yankee Candle</div>
          <div class="pname">${p.title.replace('Yankee Candle - ', '')}</div>
          <div class="match"><strong>${matchPct}% match</strong></div>
          <a class="buybtn" href="https://yankeecandle.nl/products/${handle}" target="_blank">Bekijk op de shop →</a>
        </div>
      </div>`;
  }).join('');
}

// 4. HET GEUR-RAD (SVG) GENEREREN
function polar(cx, cy, r, deg) {
  const a = (deg - 90) * Math.PI / 180;
  return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
}

function wedge(cx, cy, rIn, rOut, a0, a1) {
  const [x0, y0] = polar(cx, cy, rOut, a0);
  const [x1, y1] = polar(cx, cy, rOut, a1);
  const [x2, y2] = polar(cx, cy, rIn, a1);
  const [x3, y3] = polar(cx, cy, rIn, a0);
  return `M${x0} ${y0} A${rOut} ${rOut} 0 0 1 ${x1} ${y1} L${x2} ${y2} A${rIn} ${rIn} 0 0 0 ${x3} ${y3} Z`;
}

function buildKompas(intensity) {
  const cx = 150, cy = 150, rIn = 46, rOut = 118, seg = 360 / FAMILIES.length;
  let wedges = '';
  
  FAMILIES.forEach((f, i) => {
    const a0 = i * seg + 3, a1 = (i + 1) * seg - 3;
    // Als er geen data is (startscherm), tonen we alles op 80%
    const op = intensity ? (0.2 + (intensity[f.key] || 0) * 0.8) : 0.8;
    wedges += `<path d="${wedge(cx, cy, rIn, rOut, a0, a1)}" fill="${f.color}" fill-opacity="${op}"/>`;
  });
  
  return `
    <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
      ${wedges}
      <circle cx="150" cy="150" r="42" fill="#fff" stroke="#f0ede6" stroke-width="1"/>
    </svg>`;
}

// 5. HELPER FUNCTIES
function restart() {
  window.scrollTo({top: 0, behavior: 'smooth'});
  setTimeout(() => {
    location.reload();
  }, 300);
}

// Start het kompas op de homepagina bij het laden
document.addEventListener('DOMContentLoaded', () => {
  const introKompas = $('kompasStart');
  if (introKompas) {
    introKompas.innerHTML = buildKompas();
  }
});